export const RAN_TOURS_COLLECTION = 'ranTours';
